import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { Navigate } from 'react-router-dom';
import { auth, sms } from 'services';
import useUniversalStore from 'store/universalStore';
import { images } from 'assets/themes';
import { toast } from 'sonner';
import "./index.css";

const Login = () => {
    const { t } = useTranslation();
    const { user, write } = useUniversalStore((state) => state);
    const RESEND_WAIT_TIME = 30;
    const SUCCESS_MESSAGE = "OTP verified successfully!";
    const ERROR_TECHNICAL_MESSAGE = "Technical error. Please try again later.";
    
    const [selectedCountry, setSelectedCountry] = useState(0)
    const [otpSent, setOtpSent] = useState(false)
    const [invalid, setInValid] = useState(true)
    const [otpVerified, setOtpVerified] = useState(false)
    const [resendWaitTime, setResendWaitTime] = useState(RESEND_WAIT_TIME)
    const [loading, setLoading] = useState(false)
    const [values, setValues] = useState({
        phone: '',
        otp: '',
    })

    const countries = [
        {
            name: 'india',
            country_code: 'IN',
            dialing_code: '91',
            flag_url: images.India
        }
        // },
        // {
        //     name: 'nepal',
        //     country_code: 'NP',
        //     dialing_code: '977',
        //     flag_url: images.Nepal
        // },
        // {
        //     name: 'bangladesh',
        //     country_code: 'BD',
        //     dialing_code: '880',
        //     flag_url: images.Bangladesh
        // },
        // {
        //     name: 'pakistan',
        //     country_code: 'PK',
        //     dialing_code: '92',
        //     flag_url: images.Pakistan
        // }
    ]

    const notify = (type, message) => {
        if(type == "error"){
            toast.error(message);
        } else {
            toast.success(message);
        }
    }

    useEffect(() => {
        if (resendWaitTime && otpSent && !otpVerified)
            setTimeout(() => {
                setResendWaitTime(() => resendWaitTime - 1)
                // console.log(resendWaitTime);
            }, 1000)
    }, [resendWaitTime])

    useEffect(() => {
        //Check whether phone number is valid or not
        setInValid(!validatePhone());
    }, [values.phone])

    const validatePhone = () => {
        const temp1 = isValidPhoneNumber(
            '+' + countries[selectedCountry].dialing_code + values.phone
        ) || values.phone == ''
        let temp2;
        switch (selectedCountry) {
            case 0:
                // India
                temp2 = values.phone.length == 10
                break
            case 1:
                // Nepal
                temp2 = values.phone.length == 8
                break
            case 2:
                // Bangladesh
                temp2 = values.phone.length == 10 || values.phone.length == 9
                break
            case 3:
                // Pakistan
                temp2 = values.phone.length == 10
                break

            default:
                temp2 = false
                break
        }
        
        return temp1 && temp2
    }

    const handlePhoneChange = (e) => {
        setValues((values) => ({
            ...values,
            phone: e.target.value
        }))
    }

    const handleOtpChange = (e) => {
        setValues((values) => ({
            ...values,
            otp: e.target.value
        }))
    }

    const sendOTP = async (e) => {
        e.preventDefault();        
        setLoading(true);
        setOtpVerified(false);

        try {
            const result = await sms.sendOTP(
                countries[selectedCountry].dialing_code + values.phone);
            if (result?.type == 'success') {
                // otp sent
                setResendWaitTime(29)
                setOtpSent(true);
                notify("success", 'OTP sent to ' + values.phone + ' successfully !');
            } else if(result.message === "XMLHttpRequest failed: \"Unable to connect to the Parse API\""){
                // error due to App being Offline or Backend being down
                notify("error", ERROR_TECHNICAL_MESSAGE);
            } else {
                // Handle all errors like "OTP retry count maxed out" etc.
                notify("error", result.message)
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            // Handles any crashes or unexpected errors
            notify("error", error.message);
        }
    }

    const resendOTP = async (e, resendType) => {
        e.preventDefault();
        setLoading(true);
        setOtpVerified(false);
        // alert("resend")
        try {
            const result = await sms.resendOTP(
                countries[selectedCountry].dialing_code + values.phone, resendType);
            if (result.type == 'success') {
                if(resendType === "text"){
                    notify("success", 'OTP resent successfully !')
                } else {
                    notify("success", 'Call requested for OTP !')
                }
                setResendWaitTime(29)
            } else if(result.message === "XMLHttpRequest failed: \"Unable to connect to the Parse API\""){
                // error due to App being Offline or Backend being down
                notify("error", ERROR_TECHNICAL_MESSAGE);
            } else {
                // Handle all errors like "OTP retry count maxed out" etc.
                notify("error", result.message)
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            // Handles any crashes or unexpected errors
            notify("error", error.message);
        }
    }

    const verifyOTP = async (e) => {
        e.preventDefault();
        
        try {
            const result = await sms.verifyOTP(
              countries[selectedCountry].dialing_code + values.phone,
              values.otp
            );

            if (result.type != "error") {
                setLoading(true);
                notify("success", SUCCESS_MESSAGE);

                if(result?.type == "login"){
                    const loginResult = await auth.loginUsingSession(result.sessionToken);
                    if (loginResult.status === "success") {
                        // update user in global store
                        write({
                            user: loginResult.response
                        });
    
                        // TODO : Redirect to home page
                        window.location = "/";
                    } else {
                        notify("error", "Login failed. Please try again.");
                    }
                } else if(result?.type == "signup"){
                    // TODO : Create a profile for the newly created user
                    
                    const loginResult = await auth.loginUsingSession(result.sessionToken);
                    if (loginResult.status === "success") {
                        // update user in global store
                        write({
                            user: loginResult.response
                        });
    
                        // TODO : Redirect to home page
                        window.location = "/";

                        // TODO : Send a welcome message to the user

                        // TODO : Ask User for Business Details
                    } else {
                        notify("error", "Signup failed. Please try again.");
                    }
                }
            } else if(result.message === "XMLHttpRequest failed: \"Unable to connect to the Parse API\""){
                // error due to App being Offline or Backend being down
                setLoading(false);
                notify("error", ERROR_TECHNICAL_MESSAGE);
            } else {
                // Handles errors from msg91
                setLoading(false);
                notify("error", result.message);
            }
        } catch (error) {
            // Handles any crashes or unexpected errors
            setLoading(false);
            notify("error", error.message);
        }
    }
    
    if (user) return <Navigate to="/" />

    return (
        <div className="auth-container">
            <div className="auth-wrapper">
                <div className="auth-card">
                    <div className="auth-header">
                        <img src={images.logo} alt="Logo" className="auth-logo" />
                        <div className="auth-title">
                            <h1>Welcome to</h1>
                            <h1 className="text-danger">{t('Bahi Khata')}</h1>
                        </div>
                    </div>

                    <form onSubmit={otpSent ? verifyOTP : sendOTP} className="auth-form">
                        <div className="phone-input-group">
                            <div className="country-dropdown">
                                <button
                                    className="btn dropdown-toggle"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    title={countries[selectedCountry].name.toUpperCase()}
                                >
                                    <img
                                        src={countries[selectedCountry].flag_url}
                                        alt={countries[selectedCountry].name}
                                        className="country-flag"
                                    />
                                    <span className="country-code">
                                        +{countries[selectedCountry].dialing_code}
                                    </span>
                                </button>
                                <ul className="dropdown-menu">
                                    {countries.map((country, index) => (
                                        <li key={country.country_code}>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => setSelectedCountry(index)}
                                                type="button"
                                            >
                                                <img src={country.flag_url} alt={country.name} className="country-flag" />
                                                <span className='mx-2'>+{country.dialing_code}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <input
                                type="number"
                                className={`w-100 form-control-borderless ${invalid ? 'is-invalid' : values.phone ? 'is-valid' : ''}`}
                                placeholder="Phone number"
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '')
                                    setInValid(true);
                                }}
                                value={values.phone}
                                onChange={handlePhoneChange}
                                required
                            />
                        </div>

                        {otpSent && (
                            <div className="otp-section">
                                <input
                                    type="number"
                                    className="form-control border"
                                    placeholder="Enter OTP"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9]/g, '')
                                    }}
                                    value={values.otp}
                                    onChange={handleOtpChange}
                                    required
                                />
                                
                                <div className="resend-section">
                                    {resendWaitTime > 0 ? (
                                        <span className="timer">Resend OTP in {resendWaitTime}s</span>
                                    ) : (
                                        <div className="resend-buttons">
                                            <button onClick={(e) => resendOTP(e,"text")} className="btn btn-outline-danger">
                                                Resend via SMS
                                            </button>
                                            <button onClick={(e) => resendOTP(e,"call")} className="btn btn-outline-danger">
                                                Get OTP on Call
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={invalid || loading}
                            className="btn btn-danger py-3"
                        >
                            {loading ? (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                            ) : null}
                            {loading ? 'Please wait...' : otpSent ? 'Verify OTP' : 'Send OTP'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Login
